module.exports = __webpack_public_path__ + "img/learners.98b8b7e1.svg";